
export default function KeyFigures() {
  const figures = [
    {
      value: '20+',
      label: 'Ann\u00e9es d\u2019exp\u00e9rience',
      sublabel: 'Business & Digital',
      icon: 'ri-calendar-check-line',
    },
    {
      value: '150+',
      label: 'Entreprises accompagn\u00e9es',
      sublabel: 'PME, ETI, Grands Groupes',
      icon: 'ri-building-line',
    },
    {
      value: '10+',
      label: 'Secteurs d\u2019activit\u00e9',
      sublabel: 'Retail, Tech, Services\u2026',
      icon: 'ri-pie-chart-line',
    },
    {
      value: '100%',
      label: 'Orient\u00e9 r\u00e9sultats',
      sublabel: 'ROI mesurable',
      icon: 'ri-focus-3-line',
    },
  ];

  return (
    <section className="py-14 sm:py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {figures.map((f, i) => (
            <div
              key={i}
              className="text-center group"
            >
              <div className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center mx-auto mb-4 group-hover:bg-orange-500/20 transition-colors duration-300">
                <i className={`${f.icon} text-2xl text-orange-400`} />
              </div>
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-1">
                {f.value}
              </div>
              <div className="text-sm sm:text-base font-semibold text-white/90 mb-1">
                {f.label}
              </div>
              <div className="text-xs sm:text-sm text-white/50">
                {f.sublabel}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
